export const Color = {
    white: '#FFF',
    black: '#000000',
    transparentWhite: 'rgba(255,255,255,0.5)',
    transparentWhite36: 'rgba(255,255,255,0.36)',
    transparentBlack: 'rgba(0,0,0,0.6)',
    lightgray: 'gray',
    text: '#414341',
    transparent: '#00fffff',
    ohGrey: '#555555',
    ohGreen: '#95C48C',
    alternateGrey: '#E0E0E0',
    ohRed: '#E87D7C',
    alternateGreen: '#089864',
    yellow: '#fbcc40',

    // hover state
    ohGreenHover: '#75B469',
    unknownColor5Hover: '#37BDFF',
    lightGreyHover: '#F3F3F4',
    ohGreyHOver: '#818181',

    primary: '#ef5c34',
    unknownColor1: '#2F2F2F',
    unknownColor2: '#414141',
    unknownColor3: '#6F6F6F',
    unknownColor4: '#6E6E6E',
    unknownColor5: '#58B7E6',
    unknownColor6: '#f5f5f5',
    unknownColor7: '#c5c5c5',
    unknownColor8: '#fafafa',
    unknownColor9: '#fdd4c9',
    unknownColor10: '#222222',
    unknownColor11: '#F3C520',
    unknownColor12: '#383838',
    unknownColor13: '#2E2E2E',
    unknownColor14: '#c4c4c4',
    unknownColor15: '#333333',
    unknownColor16: '#111111',
    unknownColor17: '#c1c1c1',
    unknownColor18: '#10D08B',
    unknownColor19: '#36383c',
    unknownColor20: '#6284fa',
    unknownColor21: '#0000001f',
    unknownColor22: '#5E5E5E',
    unknownColor23: '#10d08b',
    unknownColor24: '#E5E5E5',
    unknownColor25: '#E44F4F',
    unknownColor26: '#205BDF',
}

export const NameChipColors = [
    '#B71C1C',
    '#004D40',
    '#880E4F',
    '#4A148C',
    '#0D47A1',
    '#1A237E',
    '#1B5E20',
    '#01579B',
    '#E65100',
    '#FF6F00',
]

export const artefactColors = {
    focusMode: '#191B1E',
    quiz: '#3E55A8',
}
